import React, { useState, useEffect } from "react"
import { useSelector, useStore } from "react-redux"
import { useHistory } from "react-router-dom"
import RoutineUpdateForm from "components/containers/routine/RoutineUpdateForm"
import RoutineSelectCalendar from "components/containers/routine/RoutineSelectCalendar"
import ModalText from "components/modal/ModalText"
import Bottom_Modal_var3 from "components/modal/Bottom_Modal_var3"
import serverController from "server/serverController"
import { Routineinner } from "./style"

export default function UpdateRoutineLayout({ match }) {
	const userInfo = useSelector((state) => {
		return state.userInfo
	})
	const history = useHistory()
	const store = useStore()

	const [modalOption, setModalOption] = useState("")
	const [textModalShow, setTextModalShow] = useState(false)
	const [modalShow, setModalShow] = useState(false)

	const [todotext, setTodotext] = useState("")
	const [todoalarm, setTodoalarm] = useState("")
	const [rutineDay, setRutineDay] = useState("")
	const [rutineWeek, setRutineWeek] = useState("")
	const [selectResult, setSelectResult] = useState([])
	// 페이지 이동
	const [screenIndex, setScreenIndex] = useState(0)

	var titleText = "루틴 시작날짜 / 요일"

	const clickEventList = [
		() => {
			/*alert( "윽 ")*/
		},
		() => {
			/*alert( "악 ")*/
		},
		() => {
			/*alert( "엑 ")*/
		},
		() => {
			/*alert( "큯 ")*/
		},
	]

	useEffect(() => {
		if (modalOption === "routinetxt" || modalOption === "routineDel") {
			setTextModalShow(true)
		} else if (modalOption !== "") setModalShow(true)
	}, [modalOption])

	//삭제 후 뒤로가기
	const submitClick = () => {
		history.goBack()
	}

	const [submitDay, setSubmitDay] = useState()

	const updateNext = (index) => {
		// 페이지 더 생성되면 숫자 늘려나가기
		if (screenIndex + index === -1 || screenIndex + index > 2) return
		setScreenIndex(screenIndex + index)
	}

	// 루틴데이터 받아오기
	const [routineinfo, setRoutineinfo] = useState({})
	const infoCallBack = (jsonData) => {
		if (jsonData.success !== 1) {
			alert("예기치 못한 오류가 발생하였습니다.")
			return
		} else {
			setRoutineinfo(jsonData.data)
			setTodotext(jsonData.data.title)
			setRutineWeek(jsonData.data.day)
			setSubmitDay(jsonData.data.start_date)
			setRutineDay(new Date(jsonData.data.start_date).toLocaleDateString())
		}
	}
	useEffect(() => {
		serverController.getServerData(`tasks/routines/${match.params.routine_no}`, infoCallBack)
	}, [])

	//루틴 수정
	const putCallBack = (res) => {
		if (res.success === 1) {
			history.goBack()
		} else {
			alert("예기치 못한 오류가 발생하였습니다.")
		}
	}
	const dataSubmit = () => {
		let data = {
			title: todotext,
			start_date: submitDay,
			day: rutineWeek,
		}
		serverController.updateFilePutFetchController(
			`tasks/routines/${match.params.routine_no}`,
			JSON.stringify(data),
			putCallBack
		)
	}

	let renderPageController = () => {
		switch (screenIndex) {
			case 0:
				return (
					<RoutineUpdateForm
						updateNext={updateNext}
						// setshowCalModal={setshowCalModal}
						dataSubmit={dataSubmit}
						todoalarm={todoalarm}
						setTodoalarm={setTodoalarm}
						todotext={todotext}
						setTodotext={setTodotext}
						rutineDay={rutineDay}
						rutineWeek={rutineWeek}
						selectResult={selectResult}
						routineinfo={routineinfo}
						setModalOption={setModalOption}
						history={history}
						submitDay={submitDay}
					/>
				)
			case 1:
				return (
					<RoutineSelectCalendar
						updateNext={updateNext}
						setRutineDay={setRutineDay}
						setRutineWeek={setRutineWeek}
						titleText={titleText}
						setSubmitDay={setSubmitDay}
						selectResult={selectResult}
						setSelectResult={setSelectResult}
					/>
				)
			//  updateNext={updateNext} 넘기는게 중요!!!
		}
	}

	return (
		<Routineinner>
			{renderPageController()}

			<Bottom_Modal_var3
				modalShow={modalShow} //모달 보여지는 여부
				setModalShow={setModalShow}
				modalOption={modalOption}
				clickEventList={clickEventList}
				setModalOption={setModalOption}
				// path={"/RoutineGenerate"}
			/>
			<ModalText
				setTextModalShow={setTextModalShow}
				textModalShow={textModalShow}
				modalOption={modalOption}
				submitClick={submitClick}
			/>
		</Routineinner>
	)
}
